import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDownloadDone = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 20C5.71666 20 5.479 19.904 5.287 19.712C5.09566 19.5207 5 19.2834 5 19C5 18.7167 5.09566 18.4794 5.287 18.288C5.479 18.096 5.71666 18 6 18H18C18.2833 18 18.5207 18.096 18.712 18.288C18.904 18.4794 19 18.7167 19 19C19 19.2834 18.904 19.5207 18.712 19.712C18.5207 19.904 18.2833 20 18 20H6ZM9.55 15.575C9.41666 15.575 9.29166 15.554 9.175 15.512C9.05833 15.4707 8.95 15.4 8.85 15.3L4.6 11.05C4.41666 10.8667 4.325 10.625 4.325 10.325C4.325 10.025 4.41666 9.78338 4.6 9.60005C4.78333 9.41672 5.01666 9.32505 5.3 9.32505C5.58333 9.32505 5.81666 9.41672 6 9.60005L9.55 13.15L18 4.70005C18.1833 4.51672 18.421 4.42505 18.713 4.42505C19.0043 4.42505 19.2417 4.51672 19.425 4.70005C19.6083 4.88338 19.7 5.12072 19.7 5.41205C19.7 5.70405 19.6083 5.94172 19.425 6.12505L10.25 15.3C10.15 15.4 10.0417 15.4707 9.925 15.512C9.80833 15.554 9.68333 15.575 9.55 15.575Z",
		fill: "currentColor"
	})
});
export default SvgDownloadDone;
